import Button from 'components/Button'
import ScheduleinterviewIcon from 'components/icons/ScheduleInterviewIcon'
import {
  ButtonDiv,
  FileInfoDiv,
  ResultDiv,
  ResultIconDiv,
  UploadMsgFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/ScheduledSuccessfully/style'
import React from 'react'
import { toCamelCase } from '../../../../../../utils/camelCase'
const ScheduledInterview = ({
  setPrivew,

  interviewInfo,
  selectedRoundType,
}) => {
  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
    EXTERNAL_ASSESMENT: 'Assessment',
  }
  const labelText = typeLabels[selectedRoundType?.type] || ''
  const messageType = toCamelCase(labelText)

  return (
    <UploadMsgFlex column center centerVertically>
      <ResultIconDiv>
        <ScheduleinterviewIcon />
      </ResultIconDiv>
      <ResultDiv>{messageType} Scheduled Successfully</ResultDiv>
      <FileInfoDiv>
        Time and dates for the {interviewInfo?.roundName} has been shared with
        the candidates successfully
      </FileInfoDiv>
      <ButtonDiv>
        <Button.Secondary
          text="Close"
          width="80px"
          height="36px"
          onClick={() => {
            setPrivew(false)
          }}
        />
      </ButtonDiv>
    </UploadMsgFlex>
  )
}

export default ScheduledInterview
